export default __webpack_public_path__ + "/dist/images/image3.2ae2bc070aac657b0c2fd15a02762fb0.jpg";